export default __webpack_public_path__ + "static/tour-example2-da106ea4ecdbd6be74fa985738b2b02a.png";